import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CampaignServiceApi from "apis/CampaignServiceApi";
import { setCampaignPosts } from "./campaignPosts.slice";

export const fetchCampaignPosts = createAsyncThunk(
  "campiagns/campaignPosts/fetchPosts",
  async (campaign_id: string, { dispatch, rejectWithValue }) => {
    try {
      const response = await CampaignServiceApi.getCampaignPosts({
        campaign_id,
      });
      dispatch(setCampaignPosts(response));
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      rejectWithValue(
        err.response?.data?.error || "Failed to fetch campaign posts"
      );
    }
  }
);
